import React from 'react';
import PopupContainer from '../../../common/components/PopupContainer';
import CustomButton from '../../../common/components/CustomButton';

// 追加ポップアップ
export default function MusicAlbumAddPopup1({
  hasMusic,
  onClose,
  onDone,
  onGoToMusicUpload,
} : {
  hasMusic: boolean,
  onDone: () => void,
  onGoToMusicUpload: () => void,
  onClose: () => void,
}) {
  return (
    <PopupContainer title="音楽配信サービス" onClose={() => onClose()}>
      <div className="list__body album_delivery">
        <p>
          さあ、新たなリリースを作りましょう！
          <br />
          もし収録する曲をまだアップロードしていないなら、先に「曲の管理」で曲をアップする必要があります。
        </p>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onGoToMusicUpload()}>曲の管理へ</CustomButton>
            {hasMusic && (
              <CustomButton type="default-split" onClick={() => onDone()}>作成する</CustomButton>
            )}
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
